


































import { Vue, Component, Prop } from 'vue-property-decorator';
import moment from 'moment';
import { EModalSize } from '@getaccept/lib-ui';
import ImagePreview from '@/editor/editor-block/components/ImagePreview.vue';
import { EButtonTypes } from '@lib-shared/enums/ButtonType';
import { IDocumentRevision } from '@signing-page/documents/types/document-revision';

@Component({
  components: {
    ImagePreview,
  },
  data: () => ({
    EModalSize,
    EButtonTypes,
  }),
})
export default class ReviewChangesModal extends Vue {
  @Prop() visible: boolean;
  @Prop() documentName: string;
  @Prop() sender: string;
  @Prop() latestRevision: IDocumentRevision;
  @Prop() loading: boolean;

  get day(): string {
    return moment(this.latestRevision?.createdAt).calendar({
      sameDay: '[Today]',
      lastDay: '[Yesterday]',
      lastWeek: '[Last] dddd',
      sameElse: 'DD/MM/YYYY',
    });
  }

  get time(): string {
    return moment(this.latestRevision?.createdAt).format('LT');
  }

  get message(): string {
    return this.latestRevision?.message;
  }

  handleReviewChanges() {
    const { revision } = this.latestRevision;
    this.$emit('review', revision);
  }
}
